export default __webpack_public_path__ + "static/media/1758_pall.8a3f1a58.jpg";